import { Dispatch } from "react";

import {
  AddServiceCentreRequest,
  AddServiceCentreResponse,
  DeleteServiceCentreRequest,
  DeleteServiceCentreResponse,
  GetServiceCentreByIDRequest,
  GetServiceCentreByIDResponse,
  GetServiceCentresListRequest,
  GetServiceCentresListResponse, GetServicesListRequest, GetServicesListResponse,
  ServiceCentreAddress,
  ServiceCentreItem,
  ServiceCentreLocation,
  UpdateServiceCentreItem,
  UpdateServiceCentreRequest,
  UpdateServiceCentreResponse,
} from "protobuf/service_centre_pb";
import { ServiceCentreServiceClient } from "protobuf/Service_centreServiceClientPb";
import {
  ServiceCentre,
  ServiceCentresActions,
  ServiceCentresState,
  GetState,
} from "types/store";
import { apiResponse, setModalName } from "./common-actions";
import { serviceCentreServiceClient } from "utils/grpc-clients";
import { SUCCESS_MESSAGES } from "utils/constants";
import { Struct, Value } from "google-protobuf/google/protobuf/struct_pb";

export function setServiceCentres(
  payload: ServiceCentresState["serviceCentres"]
): ServiceCentresActions {
  return {
    type: "SET_SERVICE_CENTRES_TABLE",
    payload,
  };
}

export function setSelectedServiceCentre(
  payload: ServiceCentresState["selectedServiceCentre"]
): ServiceCentresActions {
  return {
    type: "SET_SELECTED_SERVICE_CENTRE",
    payload,
  };
}
export function setServiceCentresSearch(payload: ServiceCentresState["search"]): ServiceCentresActions {
  return {
    type: "SET_SERVICE_CENTRES_SEARCH",
    payload,
  };
}

export function setMaintenanceServicesList(
    payload: ServiceCentresState["maintenanceServicesList"]
): ServiceCentresActions {
  return {
    type: "SET_MAINTENANCE_SERVICES_LIST",
    payload,
  };
}

export function initializeServiceCentres() {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const {
      common: { organizationId = "" },
    } = getState();

    const request = new GetServiceCentresListRequest();
    request.setOrganizationId(organizationId || "");

    function dispatcher(resp: GetServiceCentresListResponse) {
      const list: ServiceCentre[] =
        resp
          .getServiceCentresList()
          .map((centre) => centre.toObject() as ServiceCentreItem.AsObject) || [];
      dispatch(setServiceCentres(list));
      console.log("service centers : ", list)
    }

    dispatch(
      apiResponse<
        ServiceCentreServiceClient,
        GetServiceCentresListRequest,
        GetServiceCentresListResponse
      >({
        client: serviceCentreServiceClient,
        request,
        action: "getServiceCentresList",
        dispatcher,
        triggerLoading: true,
      })
    );
  };
}

export function getServiceCentre(id: string) {
  const request = new GetServiceCentreByIDRequest();
  request.setId(id);

  return (dispatch: Dispatch<any>) => {
    function dispatcher(resp: GetServiceCentreByIDResponse) {
      const centre = resp
        .getServiceCentreItem()
        ?.toObject() as ServiceCentreItem.AsObject | undefined;
      if (centre) {
        dispatch(setSelectedServiceCentre(centre));
      }
    }

    dispatch(
      apiResponse<
        ServiceCentreServiceClient,
        GetServiceCentreByIDRequest,
        GetServiceCentreByIDResponse
      >({
        client: serviceCentreServiceClient,
        request,
        action: "getServiceCentreByID",
        dispatcher,
        triggerLoading: true,
      })
    );
  };
}


export function getMaintenanceServicesList() {
  const request = new GetServicesListRequest();

  return (dispatch: Dispatch<any>) => {
    function dispatcher(resp: GetServicesListResponse) {
      const servicesList:ServiceCentresState["maintenanceServicesList"] = resp
          .getServicesListList().map((service) => {
            return {
              id: service.getId(),
              name: service.getName(),
            }
          })
      console.log("servicesList : ", servicesList)
      dispatch(setMaintenanceServicesList(servicesList))

    }

    dispatch(
        apiResponse<
            ServiceCentreServiceClient,
            GetServicesListRequest,
            GetServicesListResponse
        >({
          client: serviceCentreServiceClient,
          request,
          action: "getServicesList",
          dispatcher,
          triggerLoading: true,
        })
    );
  };
}

export function addServiceCentre(
  newCentre: Omit<UpdateServiceCentreItem.AsObject, "organizationId"> & {
    organizationId?: string;
  }
) {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const {
      common: { organizationId = "" },
    } = getState();

    const centreItem = buildUpdateServiceCentreItem(
      newCentre,
      newCentre.organizationId || organizationId || ""
    );

    const request = new AddServiceCentreRequest();
    request.setServiceCentreItem(centreItem);

    function dispatcher(resp: AddServiceCentreResponse) {
      const created = resp.getServiceCentreItem();
      if (created) {
        dispatch(initializeServiceCentres());
      }
    }

    dispatch(
      apiResponse<
        ServiceCentreServiceClient,
        AddServiceCentreRequest,
        AddServiceCentreResponse
      >({
        client: serviceCentreServiceClient,
        request,
        action: "addServiceCentre",
        dispatcher,
        successMessage: SUCCESS_MESSAGES.addServiceCentre,
        modalAction: true,
      })
    );
  };
}

export function editServiceCentre(
  centre: Partial<UpdateServiceCentreItem.AsObject> & { id: string }
) {
  const { id, ...rest } = centre;

  return (dispatch: Dispatch<any>, getState: GetState) => {
    const {
      common: { organizationId = "" },
    } = getState();

    const centreItem = buildUpdateServiceCentreItem(
      rest as UpdateServiceCentreItem.AsObject,
      rest.organizationId || organizationId || ""
    );

    const request = new UpdateServiceCentreRequest();
    request.setId(id);
    request.setServiceCentreItem(centreItem);

    function dispatcher() {
      dispatch(initializeServiceCentres());
      dispatch(setSelectedServiceCentre(undefined));
    }

    dispatch(
      apiResponse<
        ServiceCentreServiceClient,
        UpdateServiceCentreRequest,
        UpdateServiceCentreResponse
      >({
        client: serviceCentreServiceClient,
        request,
        action: "updateServiceCentre",
        dispatcher,
        successMessage: SUCCESS_MESSAGES.updateServiceCentre,
        modalAction: true,
      })
    );
  };
}

export function deleteServiceCentre(id: string) {
  return (dispatch: Dispatch<any>) => {
    const request = new DeleteServiceCentreRequest();
    request.setId(id);

    function dispatcher() {
      dispatch(initializeServiceCentres());
      dispatch(setSelectedServiceCentre(undefined));
      dispatch(setModalName(undefined));
    }

    dispatch(
      apiResponse<
        ServiceCentreServiceClient,
        DeleteServiceCentreRequest,
        DeleteServiceCentreResponse
      >({
        client: serviceCentreServiceClient,
        request,
        action: "deleteServiceCentre",
        dispatcher,
        successMessage: SUCCESS_MESSAGES.deleteServiceCentre,
        modalAction: true,
      })
    );
  };
}

function buildUpdateServiceCentreItem(
  data: Partial<UpdateServiceCentreItem.AsObject>,
  organizationId: string
): UpdateServiceCentreItem {
  const item = new UpdateServiceCentreItem();
  item.setOrganizationId(organizationId);
  item.setServiceCentreName(data.serviceCentreName || "");

  if (data.address) {
    const addr = new ServiceCentreAddress();
    addr.setFormattedaddress(data.address.formattedaddress || "");
    addr.setName(data.address.name || "");

    if (data.address.location) {
      const loc = new ServiceCentreLocation();
      loc.setLatitude(data.address.location.latitude || 0);
      loc.setLongitude(data.address.location.longitude || 0);
      addr.setLocation(loc);
    }

    item.setAddress(addr);
  }

  item.setServicesOffered(data.servicesOffered || "");
  item.setContactName(data.contactName || "");
  item.setContactNumber(data.contactNumber || "");
  item.setGoogleMapLink(data.googleMapLink || "");
  if (data.photo != "") {
    item.setPhoto(data.photo || "")
    item.setPhotoName(data.photoName || "")
    item.setPhotoExt(data.photoExt || "")
  }


  // Attach meta data (e.g., availability schedule) if provided
  if ((data as any)?.metaData) {
    const metaStruct = new Struct();
    const metaDataObj = (data as any).metaData;
    // Expect metaDataObj.availability as a plain object
    if (metaDataObj.availability) {
      metaStruct.getFieldsMap().set(
        "availability",
        Value.fromJavaScript(metaDataObj.availability)
      );
    }
    // Allow passing additional meta fields if present
    Object.keys(metaDataObj || {})
      .filter((key) => key !== "availability")
      .forEach((key) => {
        metaStruct.getFieldsMap().set(key, Value.fromJavaScript(metaDataObj[key]));
      });

    item.setMetaData(metaStruct);
  }

  return item;
}



